import { Category } from '../types/Category';
import { Content } from '../types/Content';
import axios from 'axios';
import api from './api';

export const fetchCategoryWithChildren = async (categoryId: string): Promise<Category> => {
  try {
    // First fetch the category
    const categoryResponse = await api.get('/categories', { params: { categoryId } });
    const category = categoryResponse.data;

    // Recursively fetch children
    const fetchChildren = async (parentCategory: Category): Promise<Category> => {
      // If it's a content category, fetch its contents
      if (parentCategory.contentCategory) {
        const contentsResponse = await api.get('/content/list', { params: { categoryId: parentCategory.id } });
        return {
          ...parentCategory,
          contents: contentsResponse.data
        };
      }

      // Fetch subcategories
      const subcategoriesResponse = await api.get('/categories/subcategories', { params: { categoryId: parentCategory.id } });
      const subcategories = subcategoriesResponse.data;
      
      if (subcategories.length === 0) {
        return parentCategory;
      }

      // Recursively fetch children for each subcategory
      const childrenPromises = subcategories.map(async (subcategory: Category) => {
        const childWithChildren = await fetchChildren(subcategory);
        return {
          ...childWithChildren,
          parentId: parentCategory.id
        };
      });

      const children = await Promise.all(childrenPromises);
      return {
        ...parentCategory,
        children,
      };
    };

    // Start the recursive fetching
    return fetchChildren(category);
  } catch (error) {
    console.error('Error fetching category with children:', error);
    throw error;
  }
};

export const updateCategoryInTree = (cats: Category[], targetId: string, updateFn: (cat: Category) => Category): Category[] => {
    return cats.map(cat => {
    if (cat.id === targetId) {
      return updateFn(cat);
    }
    if (cat.children) {
      return {
        ...cat,
            children: updateCategoryInTree(cat.children, targetId, updateFn)
          };
        }
        return cat;
      });
    };

export const suggestTreeFromCategory = async (categoryId: string, maxDepth: number, context?: string) => {
  try {
    const response = await api.post('/categories/suggest-tree', { 
      categoryId, 
      maxDepth, 
      context: context || '' 
    });
    return response.data;
  } catch (error) {
    console.error('Error suggesting tree from category:', error);
    throw error;
  }
};
